import {
  InfoModule,
  createInfoServices
} from "./chunk-5DO6E6H7.mjs";
import "./chunk-NNHCCRGN.mjs";
export {
  InfoModule,
  createInfoServices
};
